import { apiGetProvinces } from "../api/apiGetProvinces";

export const checkCoverageOffer = async (offer, energyMunicipality, gasMunicipality) => {
    // Recupera il comune dell'energia
    let gasCoverage;
    const energyCoverage = await apiGetProvinces(energyMunicipality);
    if (energyMunicipality === gasMunicipality) {
        gasCoverage = energyCoverage;
    } else {
        gasCoverage = await apiGetProvinces(gasMunicipality);
    }

    console.log(energyCoverage, gasCoverage, offer)
    // Se sono state trovato province, controlliamo l'energia perchè è coperta ovunque
    if (energyCoverage && energyCoverage.length > 0) {
        // Se la prima provincia è diversa significa che non è stato trovato
        if (energyCoverage[0].comune.toLowerCase().indexOf(energyMunicipality.toLowerCase()) === -1) {
            console.log('Municiplity not found in coverage');
            throw 'Area not covered';
        } else {
            // Se nell'offerta è presente il gas
            if (offer.gas && offer.gas.length > 0) {
                if (!gasCoverage[0].gas) {
                    console.log('Gas not covered', gasCoverage[0].gas);
                    throw 'Area not covered';
                } else {
                    // Gas è coperto
                }
            }

            // Se nell'offerta è presente la luce
            if (offer.energy && offer.energy.length > 0) {
                if (!energyCoverage[0].luce) {
                    console.log('Energy not covered', energyCoverage[0].luce);
                    throw 'Area not covered';
                } else {
                    // Luce è coperta
                }
            }
        }
    } else {
        console.log('Coverage is empty');
        throw 'Area not covered';
    }
}